import { useEffect } from 'react';
import Link from 'next/link';

import { IS_DEV } from '@lib/constants/env';
import { Routes } from '@lib/routes';

import { Button } from './button';

interface ErrorTemplateProps {
  error: Error & { digest?: string };
  message: string;
  reset: () => void;
  actionHref?: string;
  actionLabel?: string;
}

export function ErrorTemplate({
  error,
  message,
  reset,
  actionHref,
  actionLabel,
}: Readonly<ErrorTemplateProps>) {
  useEffect(() => {
    // Allow only on non-development environments
    if (IS_DEV) return;

    // TODO: Properly log this error to a reporting service in the future
    console.error('Server error: ', error.digest);
  }, [error]);

  return (
    <div
      aria-live='assertive'
      className='size-full flex-1 col-span-full flex-center flex-col text-center'
    >
      <h2 className='text-2xl font-bold'>Something went wrong!</h2>
      <p className='text-gray-600 text-sm lg:text-base'>
        {IS_DEV ? error.message : message}
      </p>
      <div className='flex-center gap-x-4 mt-6 w-full'>
        <Button asChild variant='outline' className='w-fit'>
          <Link href={actionHref ?? Routes.root} replace>
            {actionLabel ?? 'Home'}
          </Link>
        </Button>
        <Button onClick={reset} className='w-fit'>
          Try Again
        </Button>
      </div>
    </div>
  );
}
